import { Validator } from '@vista-digital/validator';
import { logger } from '../../../utils/logger';
import { loadShowtimeById } from '../../browsing/actions/showtimes/load-showtime-by-id';
import { loadSeatLayoutById } from './load-seat-layout-by-id';
/**
 * Loads the seat layout for a particular showtime.
 * @param showtimeId The unique identifier of the showtime.
 * @returns The loaded seat layout.
 */
export const loadSeatLayoutForShowtime = async (showtimeId) => {
    if (!Validator.nonEmptyString(showtimeId, logger.error, 'showtimeId')) {
        throw new Error('Cannot load seat layout. Provided showtimeId is invalid.');
    }
    const showtime = await loadShowtimeById(showtimeId);
    return loadSeatLayoutById(showtime.seatLayoutId);
};
//# sourceMappingURL=load-seat-layout-for-showtime.js.map